<template>
    <div>
        <vehicle-search-list
                :searchfields="searchFieldArgs"
                :past="past"
        />
    </div>
</template>
<script>
    export default {
        props: [
            'searchfields',
            'past',
        ],
        computed:{
            searchFieldArgs(){
                let data = {};
                if (this.searchfields) {
                    data = {...this.searchfields};
                    if (data.condition_min) {
                        data.condition_min = parseFloat(data.condition_min).toFixed(1);
                    }
                    if (data.condition_max) {
                        data.condition_max = parseFloat(data.condition_max).toFixed(1);
                    }
                }
                return data;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/SeachListPage.vue